import React, { AriaAttributes, useCallback } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

type YesNoFieldProps = {
    name?: string;
    value?: boolean;
    options: { yes: string; no: string };
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;
} & AriaAttributes;

export const DHYesNoField = ({
    name,
    value,
    options,
    onChange,
    ...ariaAttributes
}: YesNoFieldProps) => {
    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
            onChange?.(event, value === 'yes');
        },
        [onChange]
    );
    return (
        <FormControl>
            <RadioGroup
                name={name}
                {...ariaAttributes}
                row
                value={value ? 'yes' : 'no'}
                onChange={handleChange}
            >
                <FormControlLabel
                    label={options.yes}
                    control={<Radio />}
                    value='yes'
                    aria-label={options.yes}
                />
                <FormControlLabel
                    label={options.no}
                    control={<Radio />}
                    value='no'
                    aria-label={options.no}
                />
            </RadioGroup>
        </FormControl>
    );
};
